// removed by extract-text-webpack-plugin
module.exports = {"RightNav":"RightNav__ubTS7","LeftNav":"LeftNav__2xAf7","NavBtn":"NavBtn__1T_Kh","NavWrapper":"NavWrapper__D0TWr"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/NavButton/style.scss
// module id = 2g6U
// module chunks = 0